<template>
  <div class="champion">
    <div v-if="champion" class="champion-logo"></div>
    <img
      v-else-if="showPlaceholder"
      class="badge-placeholder"
      :src="placeholder"
      alt=""
    />
  </div>
  <div class="diamond">
    <div v-if="diamond" class="diamond-logo"></div>
    <img
      v-else-if="showPlaceholder"
      class="badge-placeholder"
      :src="placeholder"
      alt=""
    />
  </div>
  <div class="award">
    <div v-if="award" class="award-logo">{{ award }}</div>
    <img
      v-else-if="showPlaceholder"
      class="badge-placeholder"
      :src="placeholder"
      alt=""
    />
  </div>
</template>

<script>
import { isFlexgateEnabled, PLACEHOLDER_IMAGE } from "@/shared/flexgate";

export default {
  name: "BadgeIcons",
  props: {
    champion: { type: Boolean, default: false },
    diamond: { type: Boolean, default: false },
    award: { type: [String, Number], default: null },
  },
  setup() {
    return {
      showPlaceholder: !isFlexgateEnabled(),
      placeholder: PLACEHOLDER_IMAGE,
    };
  },
};
</script>

<style>
.badge-placeholder {
  display: block;
  width: 100%;
  height: 14px;
  object-fit: contain;
  opacity: 0.45;
}
</style>
